define('modules/editor/views/property_boxes/form_label',['require','exports','module','./base','fontmanager','ldsh!../../templates/property_boxes/form_label'],function(require, exports, module) {
  "use strict";
  var BasePropertyBox = require("./base"),
      FontManager = require("fontmanager");

  module.exports = BasePropertyBox.extend({
    template: require("ldsh!../../templates/property_boxes/form_label"),
    helpers: function() {
      return {
        fonts: FontManager.getNames()
      };
    }
  });

});

